export default __webpack_public_path__ + "static/media/instagram.06c82c33.png";